import { defineMessages } from 'react-intl';

export default defineMessages({
  formTitle: 'Review personal data',
  saveAndNext: 'Save & Next',
  response: 'Response',
  results: 'Results',
  detectedEntities: 'Detected entities',
  entity: 'Entity',
  type: 'Type',
  regulation: 'Regulation',
  confidence: 'Confidence',
  addEntity: 'Add selected text as entity',
});
